import request from '@/utils/request'

/**
 * 获取审批流节点
 * @param {*} params
 */
export function getFlowNode(params) {
    return request({
        url: '/billApprovalHr/getFlowNode',
        method: 'post',
        params: params
    })
}
/**
 * 审批流节点人员选择
 * @param {*} params
 */
export function selectUserDatas(params) {
    return request({
        url: '/billApprovalHr/selectUserDatas',
        method: 'get',
        params: params
    })
}